// ----------------------------------------------------------------------

export default function Grid(containerId: string) {
  return {
    MuiGrid: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {},
    },
  };
}
